import * as actions from '../../actions/actionTypes';

const initialState = false;

export default function fetching(state = initialState, action) {
  switch (action.type) {
    case actions.INIT_NEW_PROGRAM_RESULT:
      return initialState;
    case actions.SET_NEW_PROGRAM_FETCHING:
      return true;
    case actions.SET_NEW_PROGRAM_RESULT:
      return false;
    default:
      return state;
  }
}
